import { jsx as _jsx } from "react/jsx-runtime";
import { Controller, get, useFormContext } from 'react-hook-form';
import { Icon } from '@iconify-icon/react';
import { useDidUpdate } from '@mantine/hooks';
import Select from './Select';
const ControlledSelect = ({ name, readOnly, onChange: propsOnChange, rightSection, control: controlProp, ...props }) => {
    // Get form context - useFormContext() returns undefined if not in FormProvider, doesn't throw
    const ctx = useFormContext();
    const effectiveControl = ctx?.control ?? controlProp;
    if (!effectiveControl) {
        if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'production') {
            console.warn(`ControlledSelect "${name}" must be used inside a <FormProvider>. Rendering uncontrolled fallback.`);
        }
        return (_jsx(Select, { ...props, readOnly: readOnly, rightSection: rightSection ?? _jsx(Icon, { icon: "tabler:chevron-down", className: "text-gray-800" }), onChange: propsOnChange }));
    }
    const errors = ctx?.formState?.errors;
    const isLoading = ctx?.formState?.isLoading ?? false;
    const isSubmitting = ctx?.formState?.isSubmitting ?? false;
    const watch = ctx?.watch;
    const trigger = ctx?.trigger;
    const watchedValue = watch?.(name);
    useDidUpdate(() => {
        if (get(errors, name)?.message || watchedValue === null) {
            trigger?.(name);
        }
    }, [watchedValue]);
    return (_jsx(Controller, { name: name, control: effectiveControl, render: ({ field }) => {
            // Use watched value for display - it triggers re-renders when form state changes
            const displayValue = watchedValue ?? field.value ?? null;
            return (_jsx(Select, { ...props, name: field.name, value: displayValue, onChange: (val, option) => {
                    field.onChange(val);
                    propsOnChange?.(val, option);
                }, onBlur: field.onBlur, ref: field.ref, rightSection: rightSection ?? _jsx(Icon, { icon: "tabler:chevron-down", className: "text-gray-800" }), error: get(errors, name)?.message, "aria-invalid": !!get(errors, name), readOnly: readOnly || isLoading || isSubmitting }));
        } }));
};
export default ControlledSelect;
